// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rd-container {
  padding: 24px;
  padding-top: 0;
  max-width: 1400px;
  margin: 0 auto;
}

/* верхний блок */
.rd-header-block {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.download-main-btn {
  padding: 8px 16px;
  background: #002FA7;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  height: 38px;
}

.download-main-btn:hover {
  background: #001f7a;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.2);
}

.download-main-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* нижний блок */
.rd-content-block {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.rd-empty {
  text-align: center;
  padding: 60px 20px;
  color: #888;
  font-size: 16px;
}

.rd-content {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  min-height: 500px;
}

.rd-sidebar {
  background: #f8faff;
  border-radius: 8px;
  padding: 10px;
}

.rd-sidebar h3 {
  font-size: 16px;
  color: #002FA7;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e5ec;
}

.rd-date-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.rd-date-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 4px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.rd-date-item:hover {
  background: #eef2f6;
}

.rd-date-item.active {
  background: #e0e5f0;
  font-weight: 500;
}

.rd-date-text {
  flex: 1 1;
  font-size: 14px;
  color: #002FA7;
}

.rd-delete-btn {
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0;
}

.rd-delete-btn:hover {
  background: #ffebee;
  color: #dc3545;
}

.rd-main {
  overflow-x: auto;
}

.rd-document-header {
  margin-bottom: 24px;
}

.rd-document-header h2 {
  font-size: 18px;
  color: #002FA7;
  margin: 0;
}

.rd-group {
  margin-bottom: 32px;
}

.rd-group h3 {
  font-size: 16px;
  color: #002FA7;
  margin: 0 0 12px 0;
  padding-bottom: 6px;
  border-bottom: 1px solid #e0e5ec;
}

.rd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.rd-table th {
  background: #f8faff;
  padding: 10px 8px;
  text-align: left;
  font-weight: 600;
  color: #002FA7;
  border: 1px solid #e0e5ec;
}

.rd-table td {
  padding: 8px;
  border: 1px solid #e0e5ec;
  vertical-align: middle;
}

.rd-table tr:hover {
  background: #fafbff;
}

.rd-record-delete {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0;
}

.rd-record-delete:hover {
  background: #ffebee;
  color: #dc3545;
}

.rd-save-button-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e5ec;
}

.rd-save-btn {
  background: #002FA7;
  border: 1px solid #002FA7;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  gap: 6px;
  transition: all 0.2s;
  width: 150px;
  height: 38px;
}

.rd-save-btn:hover:not(:disabled) {
  background: #001f7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.rd-save-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  border: 1px solid #cccccc;
}

.saved-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 6px;
  background: #4caf50;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.rd-date-item.active .saved-badge {
  background: #388e3c;
}

/* статусные бейджи */
.status-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  vertical-align: middle;
}

.status-badge.saved, .status-badge.pending, .status-badge.edited {
  background: #002FA7;
  color: white;
}

/* индикаторы статуса в заголовке */
.rd-status-indicators {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.status-indicator {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.status-indicator.pending, .status-indicator.saved {
  background: #f8faff;
  color: #002FA7;
  border: 1px solid #002FA7;
}

/* сообщение о сохранённом документе */
.rd-document-saved {
  padding: 24px;
  text-align: center;
  border-radius: 8px;
}

.rd-saved-message {
  font-size: 16px;
  color: #002FA7;
  margin-bottom: 8px;
}

.rd-saved-hint {
  font-size: 14px;
  color: #666;
}

.md-error-message,
.md-success-message {
  color: white;
  font-size: 13px;
  text-align: center;
  padding: 8px 16px;
  margin: 8px auto 16px;
  max-width: 100%;
  border-radius: 6px;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.1); 
}`, "",{"version":3,"sources":["webpack://./src/md-components/ReplacementDocumentsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC","sourcesContent":[".rd-container {\n  padding: 24px;\n  padding-top: 0;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* верхний блок */\n.rd-header-block {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.download-main-btn {\n  padding: 8px 16px;\n  background: #002FA7;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  height: 38px;\n}\n\n.download-main-btn:hover {\n  background: #001f7a;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.2);\n}\n\n.download-main-btn:disabled {\n  background: #cccccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* нижний блок */\n.rd-content-block {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.rd-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: #888;\n  font-size: 16px;\n}\n\n.rd-content {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  min-height: 500px;\n}\n\n.rd-sidebar {\n  background: #f8faff;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.rd-sidebar h3 {\n  font-size: 16px;\n  color: #002FA7;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e0e5ec;\n}\n\n.rd-date-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.rd-date-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-bottom: 4px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.rd-date-item:hover {\n  background: #eef2f6;\n}\n\n.rd-date-item.active {\n  background: #e0e5f0;\n  font-weight: 500;\n}\n\n.rd-date-text {\n  flex: 1;\n  font-size: 14px;\n  color: #002FA7;\n}\n\n.rd-delete-btn {\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: transparent;\n  color: #999;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0;\n}\n\n.rd-delete-btn:hover {\n  background: #ffebee;\n  color: #dc3545;\n}\n\n.rd-main {\n  overflow-x: auto;\n}\n\n.rd-document-header {\n  margin-bottom: 24px;\n}\n\n.rd-document-header h2 {\n  font-size: 18px;\n  color: #002FA7;\n  margin: 0;\n}\n\n.rd-group {\n  margin-bottom: 32px;\n}\n\n.rd-group h3 {\n  font-size: 16px;\n  color: #002FA7;\n  margin: 0 0 12px 0;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #e0e5ec;\n}\n\n.rd-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.rd-table th {\n  background: #f8faff;\n  padding: 10px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #002FA7;\n  border: 1px solid #e0e5ec;\n}\n\n.rd-table td {\n  padding: 8px;\n  border: 1px solid #e0e5ec;\n  vertical-align: middle;\n}\n\n.rd-table tr:hover {\n  background: #fafbff;\n}\n\n.rd-record-delete {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: #999;\n  font-size: 18px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0;\n}\n\n.rd-record-delete:hover {\n  background: #ffebee;\n  color: #dc3545;\n}\n\n.rd-save-button-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e5ec;\n}\n\n.rd-save-btn {\n  background: #002FA7;\n  border: 1px solid #002FA7;\n  border-radius: 6px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  gap: 6px;\n  transition: all 0.2s;\n  width: 150px;\n  height: 38px;\n}\n\n.rd-save-btn:hover:not(:disabled) {\n  background: #001f7a;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.rd-save-btn:disabled {\n  background: #cccccc;\n  cursor: not-allowed;\n  border: 1px solid #cccccc;\n}\n\n.saved-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 6px;\n  background: #4caf50;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.rd-date-item.active .saved-badge {\n  background: #388e3c;\n}\n\n/* статусные бейджи */\n.status-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  vertical-align: middle;\n}\n\n.status-badge.saved, .status-badge.pending, .status-badge.edited {\n  background: #002FA7;\n  color: white;\n}\n\n/* индикаторы статуса в заголовке */\n.rd-status-indicators {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.status-indicator {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.status-indicator.pending, .status-indicator.saved {\n  background: #f8faff;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n}\n\n/* сообщение о сохранённом документе */\n.rd-document-saved {\n  padding: 24px;\n  text-align: center;\n  border-radius: 8px;\n}\n\n.rd-saved-message {\n  font-size: 16px;\n  color: #002FA7;\n  margin-bottom: 8px;\n}\n\n.rd-saved-hint {\n  font-size: 14px;\n  color: #666;\n}\n\n.md-error-message,\n.md-success-message {\n  color: white;\n  font-size: 13px;\n  text-align: center;\n  padding: 8px 16px;\n  margin: 8px auto 16px;\n  max-width: 100%;\n  border-radius: 6px;\n  font-weight: 500;\n  background: rgba(0, 0, 0, 0.1); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
